import React from "react"

export default function InfoOutlineIcon({
  color = "black",
  opacity = "0.4",
  ...props
}: {
  color?: string
  opacity?: string
}): JSX.Element {
  return (
    <svg {...props} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="9" cy="9" r="8" stroke={color} strokeOpacity={opacity} strokeWidth="1.5" />
      <path
        d="M7.30388 13H10.7239V12.676L10.4119 12.592C10.0159 12.496 9.96788 12.448 9.96788 11.908V8.068C9.96788 7.492 9.99188 7.06 10.0159 6.688L9.89588 6.604L7.26788 6.892V7.132L7.66388 7.396C7.99988 7.624 8.05988 7.66 8.05988 8.176V11.908C8.05988 12.424 8.01188 12.484 7.61588 12.592L7.30388 12.676V13ZM8.95988 6.016C9.54788 6.016 10.0159 5.608 10.0159 5.032C10.0159 4.444 9.54788 4.036 8.95988 4.036C8.37188 4.036 7.90388 4.444 7.90388 5.032C7.90388 5.608 8.37188 6.016 8.95988 6.016Z"
        fill={color}
        fillOpacity={opacity}
      />
    </svg>
  )
}
